// extracted by mini-css-extract-plugin
module.exports = {"input":"InputDecimal_input__25tdV"};